import { ReactComponent as LogoIcon } from "../../Asset/pages.svg";
import "./stake_holders.css";

const StaeHolders = () => {
  return (
    <div className="stake">
      <div className="header">
        <div className="wrapper">

        <div className="box-1">
          <p>Stakeholder Engagement</p>
          <h3>Connecting the Maritime Ecosystem</h3>
        </div>
        <div className="box-2">
          <p>
            {" "}
            Our platform thrives on fostering collaboration and transparency
            among maritime stakeholders. From charterers and shipowners to
            brokers and buyers, we provide a seamless digital environment where
            every interaction is efficient and purposeful.
          </p>
        </div>
        <LogoIcon/>
        </div>
      </div>

      <div className="line"></div>


      <div className="marquee-wrapper">
        <div className="marquee">
          <div className="marquee__inner">
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>

            {/* Duplicate to ensure seamless transition */}
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>
          </div>
        </div>
      </div>

     
      <div className="container">
        <div className="wrap">

       
        <div className="card-1">
          <div className="feature-card">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815579/aerial-view-of-oil-tankers-in-port-2025-01-09-12-25-41-utc_2_fzaqbd.png"
              alt="Collaboration-First Approach"
             
            />
            <h3>Collaboration-First Approach</h3>
            <p>
              We bring together charterers and owners to streamline chartering
              operations while facilitating vessel sales with trust and
              transparency.
            </p>
          </div>

          <div className="feature-card">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/lng-liquefied-natural-gas-tanker-anchored-in-gas-2024-12-08-00-54-27-utc_1_xkptra.png"
              alt="Sustainable Partnerships"
             
            />
            <h3>Sustainable Partnerships</h3>
            <p>
              Our platform enables stakeholders to align operations with
              industry regulations and environmental goals, building long-term
              resilience and growth.
            </p>
          </div>
          <div className="feature-card">
           
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/lng-liquefied-natural-gas-tanker-anchored-in-gas-2024-12-08-00-54-27-utc_1_xkptra.png"
              alt="Sustainable Partnerships"
             
            />
            <h3>Sustainable Partnerships</h3>
            <p>
              Our platform enables stakeholders to align operations with
              industry regulations and environmental goals, building long-term
              resilience and growth.
            </p>
          </div>

          <div className="feature-card">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/lng-liquefied-natural-gas-tanker-anchored-in-gas-2024-12-08-00-54-27-utc_1_xkptra.png"
              alt="Sustainable Partnerships"
             
            />
            <h3>Sustainable Partnerships</h3>
            <p>
              Our platform enables stakeholders to align operations with
              industry regulations and environmental goals, building long-term
              resilience and growth.
            </p>
          </div>
        </div>

        <div className="card-2">
          <div className="feature-card">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/aerial-view-oil-tanker-ship-oil-depot-terminal-sto-2025-01-10-04-44-09-utc_1_ebo4sq.png"
              alt="Tailored Solutions"
             
            />
            <h3>Tailored Solutions</h3>
            <p>
              By understanding the unique needs of our stakeholders, we offer
              tools and insights that empower smarter decisions.
            </p>
          </div>
          
          <div className="feature-card">
           
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/aerial-view-oil-tanker-ship-oil-depot-terminal-sto-2025-01-10-04-44-09-utc_1_ebo4sq.png"
              alt="Tailored Solutions"
             
            />
            <h3>Tailored Solutions</h3>
            <p>
              By understanding the unique needs of our stakeholders, we offer
              tools and insights that empower smarter decisions.
            </p>
          </div>
            <div className="feature-card">
              <img
                src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815581/aerial-view-oil-tanker-ship-oil-depot-terminal-sto-2025-01-10-04-44-09-utc_1_ebo4sq.png"
                alt="Tailored Solutions"
              
              />
              <h3>Tailored Solutions</h3>
              <p>
                By understanding the unique needs of our stakeholders, we offer
                tools and insights that empower smarter decisions.
              </p>
            </div>

            <div className="feature-card">
              <img
                src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736815579/aerial-view-oil-terminal-industrial-facility-stora-2025-01-08-10-36-10-utc_2_opo4hv.png"
                alt="Global Connectivity"
                
              />
              <h3>Global Connectivity</h3>
              <p>
                With a network that bridges maritime communities across the globe,
                we ensure every stakeholder has access to data and tools that
                drive efficiency and success.
              </p>
            </div>
        </div>
        </div>
      </div>

      <div className="commit">
        <div className="header">
        <h1>Our Commitment to</h1>
        <h1>Stakeholders</h1>
        </div>
        <p>We’re not just a digital platform, we’re your partner in building trust, fostering collaboration, and advancing the maritime industry toward a sustainable and connected future.</p>
      </div>
    </div>
  );
};

export default StaeHolders;
